import { gtag as _gtag } from "client/utils/adsense/gtag";

const firedEvents = new Set<string>();

export const useGoogleAnalytics = (fireOnce: boolean = false) => {
    const gtag: typeof _gtag = (...props) => {
        const eventName = props[1];
        if (fireOnce && firedEvents.has(eventName)) return;
        firedEvents.add(eventName);
        _gtag(...props);
    };
    return { gtag };
};
